<template>
  <div class="inline-block p-0 m-0 relative" ref="notificationRef">
    <span class="el-dropdown-link cursor-pointer notification_click_icon"
      @click="isNotificationVisible = !isNotificationVisible">
      <svg width="26" height="22" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M13.0001 24.3749C14.1918 24.3749 15.1668 23.3999 15.1668 22.2083H10.8335C10.8335 23.3999 11.7976 24.3749 13.0001 24.3749ZM19.5001 17.875V12.4583C19.5001 9.1325 17.7234 6.34833 14.6251 5.61167V4.875C14.6251 3.97583 13.8993 3.25 13.0001 3.25C12.1009 3.25 11.3751 3.97583 11.3751 4.875V5.61167C8.26593 6.34833 6.5001 9.12167 6.5001 12.4583V17.875L4.33344 20.0417V21.125H21.6668V20.0417L19.5001 17.875Z"
          fill="#10233E" />
      </svg>
      <i v-if="has_newNotification" class="active_notification_signal"></i>
    </span>
    <div class="notification-content" v-if="isNotificationVisible" v-loading="loading">
      <div class="top_title">
        <div class="top_nav">
          <i @click="isNotificationVisible = !isNotificationVisible"
            class="el-icon-back text-2xl mr-2 cursor-pointer"></i>
          <!-- Notifications -->
        </div>
        <div>
          <el-dropdown>
            <span class="el-dropdown-link">
              <i class="el-icon-more"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div class="actions">
                  <img src="../navbar/assets/delete_icon.svg" class="w-3 mr-2" />
                  <abbr @click="deleteAllNotification">Clear All</abbr>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="notification_navbar">
        <div class="nav_item" @click="setTab(1, 'all')" :class="active == 1 ? 'bottom_active' : null">
          All Notifications
          <span>{{ allNotifications.length }}</span>
        </div>
        <div class="nav_item" @click="setTab(2, 'read')" :class="active == 2 ? 'bottom_active' : null">
          Read
          <span>{{ totalnumberOfRead || 0 }}</span>
        </div>
        <div class="nav_item" @click="setTab(3, 'unread')" :class="active == 3 ? 'bottom_active' : null">
          Unread
          <span>{{ totalnumberOfUnRead || 0 }}</span>
        </div>
      </div>

      <div class="main_notification">
        <div v-if="!displayNotification.length" class="py-4 flex w-full justify-center flex-wrap"><img
            src="./assets/no_notification.svg" />
          <div class="w-full">
            <h4 class="w-full text-center text-lg mb-1">No notification yet</h4>
            <p class="w-full text-center opacity-50">Come back later.</p>
          </div>
        </div>
        <div class="px-2 py-2" v-for="(notification, index) in displayNotification" :key="index"
          @click="addToSelectedItem(notification._id)"
          :class="[!notification.read_status ? 'bg-gray-200' : 'bg-transparent']">
          <div class="text_notification">
            <div class="img_notification_content mr-2 mt-1">
              <img src="../../../assets/images/delivered_truck.svg" class="w-full" />
            </div>
            <div class="text_notification_content">
              <b>{{ notification.title }}</b>
              <span>{{ reduceText(notification.description) || "" }}</span>
              <abbr>{{ outputDays(notification.createdAt) }} </abbr>
            </div>
            <div>
              <!-- <span v-if="!notification.read_status" class="active_dot"></span> -->
              <!-- <span @click="deleteNotification(notification._id)" class="cursor-pointer delete_icon hidden"><img src="./assets/delete.svg"/></span> -->
              <el-dropdown>
                <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div class="actions">
                      <img src="../navbar/assets/view_icon.svg" class="w-4 mr-2" />
                      <abbr @click="viewEvent(notification)">View Event</abbr>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div class="actions">
                      <img src="../navbar/assets/delete_icon.svg" class="w-3 mr-2" />
                      <abbr @click="deleteNotification(notification._id)">Delete</abbr>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div class="footer_box">
        <div class="semi_footer flex align-center">
          <img src="../../../assets/images/setting_icon.svg" />
          <img src="../../../assets/images/read_icon.svg" class="mx-2 ml-3" />
          <span class="mark_read cursor-pointer" @click="markAllAsRead">
            Mark All As Read
          </span>
        </div>
        <div class="semi_footer flex justify-end">
          <button v-loading="loading" @click="getAllAvailableNotification"
            class="py-2 px-3 bg-primary-yellow rounded text-sm font-semibold">
            View All Notifications
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NotificationService } from "../../../services/socketFactory";
import moment from "moment"
import { userId } from "../../../services/apiConfig"
import { $_viewEvent } from "./utils/ViewEvent";

export default {
  data() {
    return {
      isNotificationVisible: false,
      notificationData: {},
      allNotifications: [],
      displayNotification: [],
      selectedNotification: [],
      hasNewNotification: false,
      active: 1,
      interval: null,
      name: "",
      loading: true,
      loadingAllNotification: false,
      notificationMeta: {}
    };
  },
  created() {
    NotificationService.setupSocketConnection();
  },
  computed: {
    notificationPayload() {
      return this.loadingAllNotification ? { perPage: this.notificationMeta?.total || null } : { perPage: 10 }
    },
    totalnumberOfUnRead() {
      const unread = this.allNotifications.filter(item => !item.read_status)
      return this.notificationData.unreadCount || unread.length
    },
    totalnumberOfRead() {
      const read = this.allNotifications.filter(item => item.read_status)
      return this.notificationData.unreadCount || read.length
    },
    has_newNotification() {
      const unreadNot = (this.allNotifications || []).filter((item) => item.read_status == false);
      return unreadNot.length > 1
    }
  },
  watch: {
  },
  methods: {
    handleOuterClick() {
      const body = document.querySelector('body');

      body.addEventListener('click', (e) => {
        const ref = this.$refs.notificationRef;

        // Make sure the ref exists before using it
        if (ref && !ref.contains(e.target)) {
          this.isNotificationVisible = false;
        }
      });
    },
    reduceText(text) {
      if (text.length > 200) {
        return text.substring(0, 170) + '...'
      }
      return text
    },
    viewEvent(notification) {
      $_viewEvent({ notification, callback: this.closeModal })
    },
    closeModal() {
      this.isNotificationVisible = false
    },
    addToSelectedItem(id) {
      let clonedSelecetedNotification = this.selectedNotification
      const selectedNotificationIndex = clonedSelecetedNotification.findIndex(_v => _v == id)
      const selectedDisplayIndex = this.displayNotification.findIndex(_v => _v?._id == id)

      if (selectedNotificationIndex > -1) {
        clonedSelecetedNotification = clonedSelecetedNotification.filter(_v => _v != id)
        this.displayNotification[selectedDisplayIndex] = { ...this.displayNotification[selectedDisplayIndex], active: false }
      } else {
        clonedSelecetedNotification.push(id)
        this.displayNotification[selectedDisplayIndex] = { ...this.displayNotification[selectedDisplayIndex], active: true }
      }

      this.selectedNotification = clonedSelecetedNotification
    },
    async deleteNotification(id) {
      await this.$_deleteNotification(id)
      await this.getAllUserNotofications(this.notificationPayload)
    },
    async deleteAllNotification() {
      await this.$_deleteAllNotification()
      await this.getAllUserNotofications(this.notificationPayload)
    },
    async markAllAsRead() {
      const ids = this.allNotifications.map(notification => { return notification._id });
      const payload = {
        userId: userId(),
        ids,
        app: "muleex"
      }
      await this.$_markAllAsRead(payload)
      await this.getAllUserNotofications(this.notificationPayload)
    },
    readNotification() {
      const read = this.allNotifications.filter(item => item.read_status)
      this.displayNotification = read
    },
    async unreadNotification() {
      const unread = this.allNotifications.filter(item => !item.read_status)
      this.displayNotification = unread

      await this.markAllAsRead()
    },
    setTab(active, name) {
      this.active = active;
      this.name = name
      switch (name) {
        case 'all':
          this.displayNotification = this.allNotifications
          break;

        case 'read':
          this.readNotification()
          break;

        case 'unread':
          this.unreadNotification()
          break;

        default:
          this.displayNotification = this.allNotifications
          break;
      }
    },
    async getAllUserNotofications(payload) {
      this.loading = true
      try {
        const response = await this.$_getAllNotifications(payload)
        this.allNotifications = response.data.notifications;
        this.displayNotification = response.data.notifications;
        this.notificationMeta = response.data.meta
        console.log("all notification ", response.data)
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        this.loadingAllNotification = true
      }
    },
    outputDays(val) {

      const days = this.numberOfDaysCreated(val)
      return days
    },
    numberOfDaysCreated(val) {
      const providedDate = moment(val);

      // Get the current date
      const currentDate = moment();
      let currentTime = null

      // Calculate the time difference
      const diffInMinutes = currentDate.diff(providedDate, 'minutes');
      const diffInHours = currentDate.diff(providedDate, 'hours');
      const diffInDays = currentDate.diff(providedDate, 'days');
      const diffInMonths = currentDate.diff(providedDate, 'months');
      const diffInYears = currentDate.diff(providedDate, 'years');


      if (diffInYears > 0) {
        currentTime = { value: diffInYears, unit: 'year ago' };
      } else if (diffInMonths > 0) {
        currentTime = { value: `${diffInMonths}`, unit: 'month ago' };
      } else if (diffInDays > 0) {
        currentTime = { value: `${diffInDays}`, unit: 'day ago' };
      } else if (diffInHours > 0) {
        currentTime = { value: `${diffInHours}`, unit: 'hour ago' };
      } else if (diffInMinutes > 0) {
        currentTime = { value: diffInMinutes, unit: 'minute ago' };
      } else {
        // If all differences are zero or negative
        currentTime = { value: 'less than ', unit: 'a minute ago' }; // Assuming 'minute' as default unit
      }

      return `${currentTime.value} ${currentTime.unit}`
    },
    getAllAvailableNotification() {
      this.getAllUserNotofications(this.notificationPayload)
    }
  },
  async mounted() {
    this.interval = setInterval(() => {
      NotificationService.Notifications().then((data) => {
        data.unreadCount != 0 && (this.hasNewNotification = true)
        let combinedNotification = [...this.allNotifications, ...data.notifications]
        const uniqueObjects = Array.from(
          new Set(combinedNotification.map((obj) => JSON.stringify(obj)))
        ).map((str) => JSON.parse(str));

        this.allNotifications = uniqueObjects
      });
    }, 2000);
    await this.getAllUserNotofications(this.notificationPayload)
    this.handleOuterClick()
  },
  beforeDestroy() {
    clearInterval(this.interval);
    document.body.removeEventListener('click', this.handleOuterClick);
  },
};
</script>

<style scoped>
.actions {
  display: inline-flex;
  align-items: center;
}

.active_notification_signal {
  position: absolute;
  display: block;
  width: 10px;
  height: 10px;
  @apply bg-secondary-yellow;
  border-radius: 50px;
  top: 0;
  right: 5px
}

.notification_click_icon {
  margin-top: 7px;
  display: inline-block;
  position: relative;
}

.mark_read {
  font-size: 14px;
}

.top_nav {
  display: flex;
  align-items: center;
}

.top_title {
  display: flex;
  align-items: center;
  padding: 0.5em;
  justify-content: space-between;
}

.footer_box {
  display: flex;
  align-items: center;
  margin: 0.8em 0em;
  padding: 0 0.6em;
}

.semi_footer {
  width: 48%;
}

.bottom_active {
  border-bottom: 2px solid rgba(16, 35, 62);
}

.active_dot {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 50px;
  @apply bg-primary-green;
}

.img_notification_content {
  width: 50px;
}

.text_notification_content b,
.text_notification_content span,
.text_notification_content abbr {
  display: block;
  width: 100%;
}

.text_notification_content b {
  font-weight: 400;
  font-size: 15px;
}

.text_notification_content span {
  opacity: 0.5;
  font-size: 13px;
}

.text_notification_content abbr {
  margin-top: 0.3em;
  font-size: 13px;
  font-weight: 200;
  opacity: 0.6
}

.text_notification_content {
  display: flex;
  flex-wrap: wrap;
  width: 94%;
}

.text_notification {
  width: 95%;
  display: flex;
}

.text_notification:hover .delete_icon {
  display: block
}

.main_notification {
  min-height: 300px;
  max-height: 60vh;
  overflow-y: auto;
}

@media all and (max-width: 767px) {

  /* CSS styles for small screens go here */
  .notification-content {
    background: white;
    left: 0%;
    width: 100vw;
    z-index: 10;
    @apply fixed rounded-md shadow;
  }
}

@media all and (min-width: 767px) {

  /* CSS styles for small screens go here */
  .notification-content {
    background: white;
    right: 0%;
    width: 500px;
    z-index: 10;
    @apply absolute shadow rounded-md;
  }
}

.notification_navbar {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 1em 0;
}

.nav_item {
  width: auto;
  margin: 0.3em 0.5em;
  padding-bottom: 0.5em;
  font-size: 14px;
  cursor: pointer;
}

.nav_item span {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50px;
  font-size: 12px;
  @apply bg-primary-navy;
  color: white;
}
</style>
